/**
 * A wrapper for DetailList to expose a different API
 */
import DetailList from '../DetailList';
import DetailListItem from '../DetailListItem';
import React from 'react';
export const LabelValueList = ({ items }) => {
    const listItems = items.map((item, index) => {
        const { label, value, isEmpty, fullWidth } = item;
        return (React.createElement(DetailListItem, { key: index, label: label, content: value, fullWidth: fullWidth, isEmpty: isEmpty }));
    });
    return React.createElement(DetailList, null, listItems);
};
//# sourceMappingURL=LabelValueList.js.map